export const getLocalStorageLanguage = () => localStorage.getItem("language");
